import React from 'react'
import styled from 'styled-components'
import { LgySection } from 'app/components/util/lgy-section/LgySection'
import { formatDateToDisplayString } from 'app/utils/dateTimeUtils'

const MAX_EVENTS_DISPLAYED = 500

const UserEventsTable = styled.table`
  margin-top: 0;
  table-layout: fixed;
  width: 100%;
  th:first-child, th:nth-child(2) {
    width: 20ch;
  }
`

const UserEvents = ({ events }) =>
  <LgySection header='Events' className='events'>
    {Array.isArray(events) && events.length > MAX_EVENTS_DISPLAYED && <span>More than {MAX_EVENTS_DISPLAYED} results were returned. Only the first {MAX_EVENTS_DISPLAYED} are shown.</span>}
    <UserEventsTable className='usa-table-borderless'>
      <thead>
        <tr>
          <th scope='col' className='event-date'>Event Date</th>
          <th scope='col' className='by-user'>By</th>
          <th scope='col' className='event-text'>Event Text</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(events) && events.slice(0, MAX_EVENTS_DISPLAYED).map(event =>
          <tr key={event.id}>
            <td>{formatDateToDisplayString(new Date(event.transactionDate))}</td>
            <td>{event.byUser}</td>
            <td>{event.eventText}</td>
          </tr>)}
      </tbody>
    </UserEventsTable>
  </LgySection>

export default UserEvents